import React from "react"
import Img from "components/Img";
import _404 from "assets/images/404.svg";
import Button from "components/Button";

import 'assets/css/PageNotFound.min.css';
import routes from "configs/routes";


const PageNotFound = () => {
    return (
        <div className="container page-not-found-container">
            <div className="row">
                <div className="col-12">
                    <Img src={ _404 } />
                </div>
                <div className="col-12 text">
                    A keresett oldal nem található
                </div>
                <div className="col-12 button-container">
                    <Button to={ routes.index } text="Vissza a főoldalra" className="large light-semi-transparent" icon="fas fa-home"/>
                </div>
                
            </div>
        </div>
    );
}

export default PageNotFound;

